(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["barra-anuncios-auguste"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initAnuncio(root) {
    if (!root || root.dataset.anunInit === 'true') return;
    root.dataset.anunInit = 'true';

    var slides = Array.prototype.slice.call(root.querySelectorAll('.anun-aug__slide'));
    if (slides.length < 2 || root.dataset.autoplay !== 'true') return;

    var speed = parseInt(root.dataset.speed, 10) || 5;
    var index = 0;
    var timer = null;

    function goTo(target) {
      index = (target + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === index);
      });
    }

    function start() {
      stop();
      timer = setInterval(function () { goTo(index + 1); }, speed * 1000);
    }

    function stop() {
      if (timer) clearInterval(timer);
      timer = null;
    }

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { stop(); } else { start(); }
    });

    root.anunGoTo = goTo;
    start();
  }

  function initAll(scope) {
    var container = scope || document;
    Array.prototype.slice.call(container.querySelectorAll('.anun-aug')).forEach(initAnuncio);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var root = event.target.closest('.anun-aug');
    if (root && typeof root.anunGoTo === 'function') {
      root.anunGoTo(parseInt(event.target.dataset.index, 10) || 0);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pie-pagina-auguste"] && !Shopify.designMode) return;
  try {
    
(function () {
  var CONSULTA = '(min-width: 750px)';

  function sincronizar(root) {
    var esEscritorio = window.matchMedia(CONSULTA).matches;
    var acordeones = Array.prototype.slice.call(root.querySelectorAll('.foot-aug__details'));

    acordeones.forEach(function (item) {
      if (esEscritorio) {
        item.open = true;
      } else if (item.dataset.footUserToggled !== 'true') {
        item.open = false;
      }
    });
  }

  function initFooter(root) {
    if (!root || root.dataset.footInit === 'true') return;
    root.dataset.footInit = 'true';

    root.querySelectorAll('.foot-aug__summary').forEach(function (summary) {
      summary.addEventListener('click', function () {
        if (!window.matchMedia(CONSULTA).matches) {
          summary.parentElement.dataset.footUserToggled = 'true';
        }
      });
    });

    sincronizar(root);

    var mq = window.matchMedia(CONSULTA);
    var alCambiar = function () {
      root.querySelectorAll('.foot-aug__details').forEach(function (item) {
        item.dataset.footUserToggled = 'false';
      });
      sincronizar(root);
    };

    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', alCambiar);
    } else if (typeof mq.addListener === 'function') {
      mq.addListener(alCambiar);
    }
  }

  function initAll(scope) {
    var container = scope || document;
    Array.prototype.slice.call(container.querySelectorAll('.foot-aug')).forEach(initFooter);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["resenas-clientas-auguste"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initAvis(root) {
    if (!root || root.dataset.avisInit === 'true') return;
    root.dataset.avisInit = 'true';

    var track = root.querySelector('[data-avis-track]');
    var prev = root.querySelector('[data-avis-prev]');
    var next = root.querySelector('[data-avis-next]');
    if (!track) return;

    function paso() {
      var card = track.querySelector('.avis-aug__card');
      if (!card) return track.clientWidth;
      var estilo = window.getComputedStyle(track);
      var gap = parseFloat(estilo.columnGap || estilo.gap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -paso(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: paso(), behavior: 'smooth' }); });
  }

  function initAll(scope) {
    var container = scope || document;
    Array.prototype.slice.call(container.querySelectorAll('.avis-aug')).forEach(initAvis);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    if (event.target.classList && event.target.classList.contains('avis-aug__card')) {
      event.target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["resenas-foto-auguste"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initAvph(root) {
    if (!root || root.dataset.avphInit === 'true') return;
    root.dataset.avphInit = 'true';

    var track = root.querySelector('[data-avph-track]');
    var puntos = Array.prototype.slice.call(root.querySelectorAll('.avph-aug__dot'));
    var tarjetas = Array.prototype.slice.call(root.querySelectorAll('.avph-aug__card'));
    if (!track || tarjetas.length < 2) return;

    var autoplay = root.dataset.autoplay === 'true';
    var segundos = parseFloat(root.dataset.speed) || 4;
    var indice = 0;
    var timer = null;

    function visibles() {
      var ancho = tarjetas[0].getBoundingClientRect().width;
      if (!ancho) return 1;
      return Math.max(1, Math.round(track.clientWidth / ancho));
    }

    function maximo() {
      return Math.max(0, tarjetas.length - visibles());
    }

    function marcar() {
      puntos.forEach(function (punto, i) {
        punto.classList.toggle('is-active', i === indice);
      });
    }

    function irA(destino) {
      var tope = maximo();
      indice = destino > tope ? 0 : destino;
      if (indice < 0) indice = tope;
      track.scrollTo({ left: tarjetas[indice].offsetLeft - tarjetas[0].offsetLeft, behavior: 'smooth' });
      marcar();
    }

    function arrancar() {
      if (!autoplay) return;
      detener();
      timer = setInterval(function () { irA(indice + 1); }, segundos * 1000);
    }

    function detener() {
      if (timer) clearInterval(timer);
      timer = null;
    }

    puntos.forEach(function (punto) {
      punto.addEventListener('click', function () {
        irA(parseInt(punto.dataset.index, 10) || 0);
        arrancar();
      });
    });

    root.addEventListener('mouseenter', detener);
    root.addEventListener('mouseleave', arrancar);
    track.addEventListener('touchstart', detener, { passive: true });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { detener(); } else { arrancar(); }
    });

    root.avphGoTo = irA;
    marcar();
    arrancar();
  }

  function initAll(scope) {
    var container = scope || document;
    Array.prototype.slice.call(container.querySelectorAll('.avph-aug')).forEach(initAvph);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });

  document.addEventListener('shopify:block:select', function (event) {
    var root = event.target.closest('.avph-aug');
    if (root && typeof root.avphGoTo === 'function') {
      var tarjetas = Array.prototype.slice.call(root.querySelectorAll('.avph-aug__card'));
      root.avphGoTo(tarjetas.indexOf(event.target));
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider-principal-auguste"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initHeroAug(root) {
    if (!root || root.dataset.heroInit === 'true') return;
    root.dataset.heroInit = 'true';

    var slides = Array.prototype.slice.call(root.querySelectorAll('.hero-aug__slide'));
    var bars = Array.prototype.slice.call(root.querySelectorAll('.hero-aug__bar'));
    var prev = root.querySelector('.hero-aug__arrow--prev');
    var next = root.querySelector('.hero-aug__arrow--next');
    var autoplay = root.dataset.autoplay === 'true';
    var index = 0;

    if (slides.length < 2) {
      if (prev) prev.style.display = 'none';
      if (next) next.style.display = 'none';
      return;
    }

    function restartActiveBar() {
      var bar = bars[index];
      if (!bar) return;
      var fill = bar.querySelector('.hero-aug__bar-fill');
      if (!fill) return;
      fill.style.animation = 'none';
      void fill.offsetWidth;
      fill.style.animation = '';
    }

    function restartActiveMedia() {
      var media = slides[index].querySelector('.hero-aug__img, .hero-aug__video');
      if (!media) return;
      media.style.animation = 'none';
      void media.offsetWidth;
      media.style.animation = '';
      if (media.tagName === 'VIDEO' && typeof media.play === 'function') {
        var playPromise = media.play();
        if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(function () {});
      }
    }

    function goTo(target) {
      index = (target + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === index);
      });
      bars.forEach(function (bar, i) {
        bar.classList.toggle('is-active', i === index);
      });
      restartActiveBar();
      restartActiveMedia();
    }

    root.addEventListener('animationend', function (event) {
      if (!autoplay) return;
      if (!event.target.classList.contains('hero-aug__bar-fill')) return;
      if (!event.target.parentElement.classList.contains('is-active')) return;
      goTo(index + 1);
    });

    if (prev) prev.addEventListener('click', function () { goTo(index - 1); });
    if (next) next.addEventListener('click', function () { goTo(index + 1); });

    bars.forEach(function (bar) {
      bar.addEventListener('click', function () {
        goTo(parseInt(bar.dataset.index, 10) || 0);
      });
    });

    var touchStartX = null;
    root.addEventListener('touchstart', function (event) {
      touchStartX = event.changedTouches[0].clientX;
    }, { passive: true });

    root.addEventListener('touchend', function (event) {
      if (touchStartX === null) return;
      var delta = event.changedTouches[0].clientX - touchStartX;
      if (Math.abs(delta) > 45) goTo(delta < 0 ? index + 1 : index - 1);
      touchStartX = null;
    }, { passive: true });

    root.heroAugGoTo = goTo;
    restartActiveBar();
  }

  function initAll(scope) {
    var container = scope || document;
    Array.prototype.slice.call(container.querySelectorAll('.hero-aug')).forEach(initHeroAug);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var root = event.target.closest('.hero-aug');
    if (root && typeof root.heroAugGoTo === 'function') {
      root.heroAugGoTo(parseInt(event.target.dataset.index, 10) || 0);
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
